<script setup lang="ts">
  import { ref } from 'vue';
  import PosUiButton from '@/components/pos-v2/ui/PosUiButton.vue';
  import PosUiEmptyState from '@/components/pos-v2/ui/PosUiEmptyState.vue';
  import { useCatalogPage } from '@/composition/catalog/catalog-page-context';

  /** «No pudimos cargar su menú» [Reintentar] (plan §5.16). */
  const { data } = useCatalogPage();
  const retrying = ref(false);

  async function retry() {
    retrying.value = true;
    try {
      await data.reloadCatalog();
    } catch {
      // The page keeps showing this state; the owner can try again.
    } finally {
      retrying.value = false;
    }
  }
</script>

<template>
  <div class="v2-catalog-load-error">
    <PosUiEmptyState
      icon="cloud-alert"
      :title="$t('menuPage.states.loadError')"
      :description="$t('menuPage.states.loadErrorHint')"
    >
      <template #action>
        <PosUiButton
          color="neutral"
          variant="outline"
          icon="refresh"
          :disabled="retrying"
          @click="retry"
          >{{ $t('menuPage.states.retry') }}</PosUiButton
        >
      </template>
    </PosUiEmptyState>
  </div>
</template>

<style scoped lang="scss">
  .v2-catalog-load-error {
    @apply tw-mx-auto tw-mt-6 tw-rounded-xl tw-border tw-border-solid tw-border-neutral-200 tw-bg-surface;
    max-width: 640px;
  }
</style>
